export enum CSVUploadStatus {
  Processing = 'processing',
  Success = 'success',
  Warning = 'warning',
  Failed = 'failed',
}
